var _circle, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBills(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F6F6F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.1665 14.4997V16.718C29.1665 18.1663 28.2498 19.083 26.8015 19.083H23.6665V12.6755C23.6665 11.658 24.5007 10.833 25.5182 10.833C26.5173 10.8422 27.434 11.2455 28.094 11.9055C28.754 12.5747 29.1665 13.4913 29.1665 14.4997Z",
    fill: "#292D32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.8335 15.4163V28.2497C10.8335 29.0105 11.6952 29.4413 12.3002 28.983L13.8677 27.8097C14.2343 27.5347 14.7477 27.5713 15.0777 27.9013L16.5993 29.4322C16.9568 29.7897 17.5435 29.7897 17.901 29.4322L19.441 27.8922C19.7618 27.5713 20.2752 27.5347 20.6327 27.8097L22.2002 28.983C22.8052 29.4322 23.6668 29.0013 23.6668 28.2497V12.6663C23.6668 11.658 24.4918 10.833 25.5002 10.833H15.4168H14.5002C11.7502 10.833 10.8335 12.4738 10.8335 14.4997V15.4163Z",
    fill: "#292D32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7707 18.8545H14.729C14.3532 18.8545 14.0415 18.5428 14.0415 18.167C14.0415 17.7912 14.3532 17.4795 14.729 17.4795H19.7707C20.1465 17.4795 20.4582 17.7912 20.4582 18.167C20.4582 18.5428 20.1465 18.8545 19.7707 18.8545Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBills);
export default __webpack_public_path__ + "static/media/Bills.24719550.svg";
export { ForwardRef as ReactComponent };